import React from "react";
import { Background } from "components/background/Background";
import { Clock } from "components/clock/Clock";
import { Date } from "components/date/Date";
import { Quote } from "components/quote/Quote";
import styled from "styled-components";
import shade from "assets/shade.png";

export const App = () => {
  return (
    <AppWrapper>
      <Background/>
      <ContentWrapper>
        <Content>
          <Clock />
          <Date />
          <Quote />
        </Content>
      </ContentWrapper>
    </AppWrapper>
  );
};

const AppWrapper = styled.div`
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  width: 100%;
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  color: #fff;
  background: url(${shade});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const Content = styled.div`
  padding: 15px;
`;
